import React from "react";
import ProfilePic from "../../../assets/images/profile.jpg";

const Profile = () => {
  return (
    <div className="my-5 flex justify-start space-x-3 items-center">
      <div className="w-14 h-14 md:w-20 md:h-20 bg-gray-400 rounded-full"></div>
      <p className="md:text-lg w-40 sm:w-auto text-xl font-semibold">
        Company Name
      </p>
    </div>
  );
};

export default Profile;
